<footer class="bg-[#1a1a1a] text-white pt-10 sm:pt-16 pb-6 sm:pb-8 border-t border-[#D4AF37]">
    <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 mb-8 sm:mb-12 grid grid-cols-1 md:grid-cols-4 gap-6 sm:gap-8">
        <div class="md:col-span-1">
            <!-- Logo on Glass/White Card -->
            <div
                class="bg-white/10 backdrop-blur-md p-3 sm:p-4 rounded-xl inline-block mb-4 sm:mb-6 border border-white/20">
                <img ngSrc="/content/Logos/vettroTradersAndIntegratedServices_BrandLogo-1.svg" alt="Vettro Traders Logo"
                    width="192" height="64" class="h-12 sm:h-16 w-auto max-w-full">
            </div>
            <p class="text-gray-400 text-sm leading-relaxed">
                {{ description }}
            </p>
        </div>

        <div>
            <h3 class="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-6">Quick Links</h3>
            <ul class="space-y-3 text-sm text-gray-400">
                <li><a routerLink="/" class="hover:text-white transition-colors">Home</a></li>
                <li><a routerLink="/services" class="hover:text-white transition-colors">Our Services</a></li>
                <li><a routerLink="/ecosystem" class="hover:text-white transition-colors">Ecosystem</a></li>
                <li><a routerLink="/contact" class="hover:text-white transition-colors">Contact</a></li>
                <li><a routerLink="/gallery" class="hover:text-white transition-colors">Gallery</a></li>
                <li><a routerLink="/reviews" class="hover:text-white transition-colors">Reviews & Location</a></li>
            </ul>
        </div>

        <div>
            <h3 class="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-6">Branches</h3>
            <ul class="space-y-3 text-sm text-gray-400">
                @for (branch of branches(); track branch._id) {
                <li>
                    <a [href]="branch.mapUrl" target="_blank" class="hover:text-white transition-colors">
                        {{ branch.name }}
                    </a>
                </li>
                }
            </ul>
        </div>
        <div>
            <h3 class="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-6">Connect</h3>
            <div class="flex space-x-4">
                <a href="https://www.facebook.com/p/Vettro-Traders-Integrated-Services-100067848352770/" target="_blank"
                    aria-label="Facebook"
                    class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D4AF37] transition-colors">
                    <!-- Facebook SVG -->
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                </a>
                <a href="https://www.instagram.com/vettrotraders/" target="_blank" aria-label="Instagram"
                    class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D4AF37] transition-colors">
                    <!-- Instagram SVG -->
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                </a>
                <a href="https://www.linkedin.com/in/abdul-salim-417423299?originalSubdomain=in" target="_blank"
                    aria-label="LinkedIn"
                    class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D4AF37] transition-colors">
                    <!-- LinkedIn SVG -->
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                </a>
            </div>
        </div>
    </div>
    <div class="border-t border-gray-800 pt-6 sm:pt-8 text-center text-xs text-gray-400 px-3">
        <p class="break-words">&copy; {{ currentYear }} Vettro Traders & Integrated Services. All Rights Reserved.</p>
        <p class="mt-2">Developed by <a href="https://abdulharis.is-a.dev/" target="_blank"
                class="hover:text-white transition-colors font-medium">AH Logic</a></p>
    </div>
</footer>